<section class="clients-page">
  <header class="page-header">
    <div>
      <p class="eyebrow">Logistics</p>
      <h2>Clients</h2>
      <p class="subtitle">One row per distinct phone number, with direct outreach and order history.</p>
    </div>
  </header>

  <section class="toolbar-card">
    <mat-form-field appearance="outline">
      <mat-label>Search client or phone</mat-label>
      <input matInput [value]="search" (keyup.enter)="applySearch($event)" (blur)="applySearch($event)">
    </mat-form-field>

    <div class="toolbar-actions">
      <button mat-stroked-button color="primary" (click)="resetSearch()">Reset</button>
      <button mat-flat-button color="primary" (click)="loadClients()">Refresh</button>
    </div>
  </section>

  <section class="table-card">
    <div class="table-wrapper" *ngIf="!loading; else loadingState">
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Client</th>
          <td mat-cell *matCellDef="let row">
            <div class="primary-cell">
              <strong>{{ row.customerName }}</strong>
              <small>{{ row.lastDriverName || 'No recent rider' }}</small>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="contactNumber">
          <th mat-header-cell *matHeaderCellDef>Phone</th>
          <td mat-cell *matCellDef="let row">
            <div class="primary-cell">
              <strong>{{ row.contactNumber }}</strong>
              <small>{{ row.normalizedContactNumber }}</small>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="totalOrders">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Orders</th>
          <td mat-cell *matCellDef="let row">{{ row.totalOrders }}</td>
        </ng-container>

        <ng-container matColumnDef="activeOrders">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
          <td mat-cell *matCellDef="let row">{{ row.activeOrders }}</td>
        </ng-container>

        <ng-container matColumnDef="paidOrders">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Paid</th>
          <td mat-cell *matCellDef="let row">{{ row.paidOrders }}</td>
        </ng-container>

        <ng-container matColumnDef="totalSpend">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Spend</th>
          <td mat-cell *matCellDef="let row">{{ row.totalSpend | currency:'NGN':'symbol':'1.0-0' }}</td>
        </ng-container>

        <ng-container matColumnDef="lastOrderDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Order</th>
          <td mat-cell *matCellDef="let row">{{ row.lastOrderDate ? (row.lastOrderDate | date:'medium') : '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="lastRoute">
          <th mat-header-cell *matHeaderCellDef>Last Route</th>
          <td mat-cell *matCellDef="let row">
            <div class="primary-cell">
              <strong>{{ row.lastPickupLocation || '-' }}</strong>
              <small>{{ row.lastDeliveryLocation || '-' }}</small>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row">
            <div class="row-actions">
              <button mat-stroked-button color="primary" (click)="openHistory(row)">History</button>
              <button mat-flat-button color="primary" (click)="sendMessage(row)">Message</button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50]"></mat-paginator>
    </div>

    <ng-template #loadingState>
      <div class="empty-state">Loading logistics clients...</div>
    </ng-template>
  </section>

  <section class="history-card" *ngIf="selectedClient">
    <div class="history-header">
      <div>
        <p class="eyebrow">Client History</p>
        <h3>{{ selectedClient.customerName }}</h3>
        <p>{{ selectedClient.contactNumber }}</p>
      </div>
      <button mat-stroked-button (click)="selectedClient = null">Close</button>
    </div>

    <div class="history-list" *ngIf="!loadingOrders; else loadingOrdersState">
      <article class="history-item" *ngFor="let order of clientOrders">
        <div class="history-main">
          <strong>{{ order.item || 'Delivery Order' }}</strong>
          <span>{{ order.orderDate | date:'medium' }}</span>
        </div>
        <div class="history-meta">
          <span>{{ order.pickupLocation || '-' }} -> {{ order.deliveryLocation || '-' }}</span>
          <span>{{ order.driverName || 'Unassigned rider' }} / {{ order.vehicleNumber || 'No vehicle' }}</span>
          <span>{{ order.amount | currency:'NGN':'symbol':'1.0-0' }}</span>
        </div>
      </article>

      <p class="empty-state" *ngIf="!clientOrders.length">No orders found for this contact.</p>
    </div>

    <ng-template #loadingOrdersState>
      <div class="empty-state">Loading client history...</div>
    </ng-template>
  </section>
</section>
